import { graphql, useStaticQuery } from "gatsby"
import { useEffect, useState } from "react"

const useAllAvailableLocales = () => {
  const [languages, setLanguages] = useState<string[]>([])

  const content = useStaticQuery(graphql`
    query {
      pages: allMarkdownRemark {
        edges {
          node {
            frontmatter {
              translations {
                locale
              }
            }
          }
        }
      }
      locales: allLocalesJson {
        edges {
          node {
            title
          }
        }
      }
    }
  `)

  useEffect(() => {
    if (content?.pages?.edges) {
      let localeSet = new Set<string>()

      content.pages.edges.forEach((f) => {
        if (f.node && f.node.frontmatter.translations) {
          f.node.frontmatter.translations.forEach((t) => {
            localeSet.add(t.locale)
          })
        }
      })

      // Note any attempted translations
      const localeFiles = content.locales.edges
      localeFiles.forEach((f) => {
        localeSet.add(f.node.title)
      })

      setLanguages(Array.from(localeSet).sort())
    }
  }, [content])

  return languages
}

export default useAllAvailableLocales
